import ClinicList from "@/views/clinic/cliniclist/ClinicList"
export const cliniclist = {
    path: '/cliniclist',
    name: 'ClinicList',
    component: ClinicList
  }


// WEBPACK FOOTER //
// ./src/router/index/clinic/cliniclist/index.js